/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Person_PlaceholderInputs */



/**
* | output |
* | --- |
* | "boris@example.com" |
*
* @param {Meetings_Exception_Person_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_person_placeholder = /** @type {((inputs?: Meetings_Exception_Person_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Person_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("boris@voorbeeld.be")
	if (locale === "fr") return /** @type {LocalizedString} */ ("boris@exemple.be")
	return /** @type {LocalizedString} */ ("boris@example.com")
});